import { FieldCheckbox } from '@/components/looker/field-checkbox';

export type NoiseFilterProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export function NoiseFilter({ value, onChange }: NoiseFilterProps) {
  return (
    <FieldCheckbox
      className="mt-8"
      label="Filter Noise"
      checked={value}
      onChange={(e) => onChange(e.currentTarget.checked)}
    />
  );
}
